export * from '@primeuix/themes/aura/tabs';
export { default } from '@primeuix/themes/aura/tabs';
